import React from 'react'
import { Divider, Typography } from 'antd'
import { BLOCKS } from '@contentful/rich-text-types'
import { ContentfulRenderTable } from 'components/Contentful/ContentfulRenderTable'
import { ContentfulRenderAsset } from 'components/Contentful/ContentfulRenderAsset'
import { ContentfulRenderHeading } from 'components/Contentful/ContentfulRenderHeading'

const { Paragraph, Text } = Typography

export const getContentfulNodeRenderers = (assets: any[]) => ({
  renderNode: {
    [BLOCKS.TABLE]: (node) => ContentfulRenderTable(node, getContentfulNodeRenderers(assets)),
    [BLOCKS.TABLE_ROW]: () => null,
    [BLOCKS.TABLE_CELL]: (node, children) => <div>{children}</div>,
    [BLOCKS.TABLE_HEADER_CELL]: (node, children) => <strong>{children}</strong>,
    [BLOCKS.EMBEDDED_ASSET]: (node) => <ContentfulRenderAsset node={node} assets={assets} />,
    [BLOCKS.HEADING_1]: (node) => ContentfulRenderHeading(1, node),
    [BLOCKS.HEADING_2]: (node) => ContentfulRenderHeading(2, node),
    [BLOCKS.HEADING_3]: (node) => ContentfulRenderHeading(3, node),
    [BLOCKS.HEADING_4]: (node) => ContentfulRenderHeading(4, node),
    [BLOCKS.PARAGRAPH]: (node, children) => <Paragraph>{children}</Paragraph>,
    [BLOCKS.HR]: () => <Divider />,
    [BLOCKS.UL_LIST]: (node, children) => (
      <Paragraph>
        <ul style={{ paddingLeft: 20, margin: 0 }}>{children}</ul>
      </Paragraph>
    ),
    [BLOCKS.OL_LIST]: (node, children) => (
      <Paragraph>
        <ol style={{ paddingLeft: 20, margin: 0 }}>{children}</ol>
      </Paragraph>
    ),
    [BLOCKS.LIST_ITEM]: (node, children) => (
      <li>
        <Text>{children}</Text>
      </li>
    ),
  },
})
